import { useQuery } from '@tanstack/react-query';
import { adminService, CompanyInfo } from '../services/admin.service';
import { useAuth, isAdminUser } from './useAuth';

/**
 * 会社情報を取得するカスタムフック
 * 認証不要で全員がアクセス可能（読み取り専用）
 */
export function useCompanyInfo() {
  const { user } = useAuth();
  const isAdmin = isAdminUser(user);

  const { data: companyInfo, isLoading, error } = useQuery<CompanyInfo | null>({
    queryKey: ['admin', 'company-info'],
    queryFn: async () => {
      try {
        return await adminService.getCompanyInfo();
      } catch (error: any) {
        // エラーが発生した場合はnullを返す（公開APIとして扱う）
        console.warn('Failed to fetch company info:', error);
        return null;
      }
    },
    staleTime: 5 * 60 * 1000, // 5分間キャッシュ
    retry: false,
  });

  return {
    companyInfo,
    isLoading,
    error,
    isAdmin,
  };
}

